import { render, staticRenderFns } from "./Phq4.vue?vue&type=template&id=34376dfe&scoped=true&"
import script from "./Phq4.vue?vue&type=script&lang=ts&"
export * from "./Phq4.vue?vue&type=script&lang=ts&"
import style0 from "./Phq4.vue?vue&type=style&index=0&id=34376dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34376dfe",
  null
  
)

export default component.exports